const initialState = {
  planHistory: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'POPULATE_PLAN_HISTORY':
      return {
        ...state,
        planHistory: action.planHistory,
      };
    default:
      return state;
  }
};
